import request from '@/utils/request'
import axios from 'axios'
import store from '@/store'
export function getuserportfolios() {
  return request({
    url: '/portfolio/portfoliolist',
    method: 'get'
  })
}

export function getfullportfolio(datajson) {
  return request({
    url: '/portfolio/getfullportfolio',
    method: 'post',
    timeout: 60000,
    data: datajson,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

export function uploaduserportfolio(data) {
  return request({
    url: '/portfolio/upload',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

export function matchportfolio(datajson) {
  return request({
    url: '/portfolio/match',
    method: 'post',
    data: datajson,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

export function findportfoliotypos(datajson) {
  return request({
    url: '/portfolio/FindPortfolioTypos',
    method: 'post',
    data: datajson,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

export function setportfoliovalidation(datajson) {
  return request({
    url: '/portfolio/setportfoliovalidation',
    method: 'post',
    data: datajson,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

export function loadbrainsdata(datajson) {
  return request({
    url: '/portfolio/loadbrainsdata',
    method: 'post',
    data: datajson,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

export function DownloadPortfolio(id) {
  return axios.post(window._env_.VUE_APP_BRAINS_API + '/portfolio/DownloadPortfolio',
    { Id: id },
    {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + store.state.user.token
      },
      responseType: 'arraybuffer'
    }
  )
}

export function DeletePortfolio(id) {
  const datajson = JSON.stringify({ Id: id })
  return request({
    url: '/portfolio/DeletePortfolio',
    method: 'post',
    data: datajson,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

export function getstrattable(stratquery) {
  // findRequest = JSON.stringify(findRequest)
  return request({
    url: '/portfolio/stratstable',
    method: 'post',
    data: stratquery,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

export function getstrattablefilter(stratquery) {
  // findRequest = JSON.stringify(findRequest)
  return request({
    url: '/portfolio/stratstablefilter',
    method: 'post',
    data: stratquery,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

export function saveportfolioconfig(datajson) {
  return request({
    url: '/portfolio/saveportfolioconfig',
    method: 'post',
    data: datajson,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}
